module.exports = __webpack_public_path__ + "static/media/homeBg.2eaa0e84.png";